import { render, staticRenderFns } from "./driverRecruitList.vue?vue&type=template&id=6e57bff4&scoped=true&"
import script from "./driverRecruitList.vue?vue&type=script&lang=js&"
export * from "./driverRecruitList.vue?vue&type=script&lang=js&"
import style0 from "./driverRecruitList.vue?vue&type=style&index=0&id=6e57bff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e57bff4",
  null
  
)

export default component.exports